import bone from 'assets/icons/engraving/bone.png';
import catsPaw from 'assets/icons/engraving/cats-paw.png';
import catOne from 'assets/icons/engraving/cat-one.png';
import catTwo from 'assets/icons/engraving/cat-two.png';
import catThree from 'assets/icons/engraving/cat-three.png';
import catFour from 'assets/icons/engraving/cat-four.png';
import dogPaw from 'assets/icons/engraving/dog-paw.png';
import dog from 'assets/icons/engraving/dog.png';
import doubleCatPaw from 'assets/icons/engraving/double-cat-paw.png';
import heart from 'assets/icons/engraving/heart.png';
import horse from 'assets/icons/engraving/horse.png';

export default Object.freeze([
    {
        name: 'None',
        value: 'None',
        path: null
    },
    {
        name: 'Bone',
        value: 'Bone',
        path: bone
    },
    {
        name: 'Cat\'s Paw',
        value: 'Cat\'s Paw',
        path: catsPaw
    },
    {
        name: 'Cat 1',
        value: 'Cat 1',
        path: catOne
    },
    {
        name: 'Cat 2',
        value: 'Cat 2',
        path: catTwo
    },
    {
        name: 'Cat 3',
        value: 'Cat 3',
        path: catThree
    },
    {
        name: 'Cat 4',
        value: 'Cat 4',
        path: catFour
    },
    {
        name: 'Dog Paw',
        value: 'Dog Paw',
        path: dogPaw
    },
    {
        name: 'Dog',
        value: 'Dog',
        path: dog
    },
    {
        name: 'Double Cat Paw',
        value: 'Double Cat Paw',
        path: doubleCatPaw
    },
    {
        name: 'Heart',
        value: 'Heart',
        path: heart
    },
    {
        name: 'Horse',
        value: 'Horse',
        path: horse
    }
]);
